import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';
import { ROUTE_NAME, ROUTE_PATH } from 'utils/constants/router';
import { fetchWithTimeout } from 'functions/fetchWithTimeout';
import configs from '../configs';
import handleResponse from './handleResponse';
import { clearAuthDataInLocalStorage } from './clearAuthDataInLocalStorage';

let fetchingPromise = null;

export const getAccessToken = () => {
  const refreshToken = localStorage.getItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);
  if (!refreshToken) {
    window.location.replace(`${window.location.origin}${ROUTE_PATH[ROUTE_NAME.LOGIN]}`);
    return null;
  }

  if (fetchingPromise) {
    return fetchingPromise;
  }

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET',
      'Access-Control-Allow-Headers': 'content-type',
      Authorization: `Bearer ${refreshToken}`,
    },
  };

  fetchingPromise = fetchWithTimeout({ resource: `${configs.beApiUrl}/token`, options: requestOptions, timeout: 10000 })
    .then(handleResponse)
    .then((result) => {
      const { token } = result;
      localStorage.setItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, token);
      return token;
    })
    .catch((ex) => {
      console.error('Error occurred, while getting new "access_token":', ex);
      clearAuthDataInLocalStorage();
    })
    .finally(() => {
      fetchingPromise = null;
    });

  return fetchingPromise;
};
